import dayjs from "dayjs";
import { General } from "./smartComponents/General";
import { Goals } from "./smartComponents/Goals";
import { Dashboard } from "./smartComponents/Dashboard";
import { Retention } from "./smartComponents/Retention";
import { Extra } from "./smartComponents/Extra";
import { Pages } from "./smartComponents/Pages";
import { Clubready } from "./smartComponents/Clubready";

const MIN_YEAR = 2012;
const CURRENT_YEAR = dayjs().year();

function getActiveYears() {
  let years = [];

  for (let i = MIN_YEAR; i <= CURRENT_YEAR; i++) {
    years.push({ name: i });
  }

  return years.reverse();
}

export const FILTER_OPTIONS = {
  activeYears: getActiveYears(),
  currencyList: ["$", "€", "£"],
  beginningOfWeek: [
    { id: "sunday", name: "Sunday" },
    { id: "monday", name: "Monday" }
  ],
  dailyEmailNotifier: ["DailyEmailNotifier", "RowHouseDailyEmailNotifier"],
  attritionRateLogic: [
    { id: "rolling30Days", name: "Rolling 30 Days" },
    { id: "monthly", name: "Monthly" }
  ],
  membershipMetrics: [
    { id: "NumberOfMembersByStatus", name: "Number Of MembersByStatus - iKizmet logic" },
    { id: "NumberOfMembersByProfile", name: "Number Of Members By Profile - Clubready logic" },
    {
      id: "NumberOfPayingMembersByPricingOption",
      name: "Number Of Paying MembersBy Pricing Option"
    },
    {
      id: "NumberOfPayingMembersByPricingOptionExcludingZeroSales",
      name: "Number Of Paying MembersBy Pricing Option Excluding Zero Sales"
    }
  ],
  membershipStart: [
    { id: "sale_date", name: "Sale Date" },
    { id: "start_date", name: "Start Date" }
  ],
  categoryList: [
    { id: "barre", name: "Barre" },
    { id: "basketball", name: "Basketball" },
    { id: "bootcamp", name: "Boot Camp" },
    { id: "boxing", name: "Boxing" },
    { id: "cycling", name: "Cycling" },
    { id: "dance_fitness", name: "Dance Fitness" },
    { id: "ems", name: "EMS" },
    { id: "general_fitness", name: "General Fitness" },
    { id: "hiit", name: "HIIT" },
    { id: "kickboxing", name: "Kickboxing" },
    { id: "martial_arts", name: "Martial Arts" },
    { id: "outdoor_fitness", name: "Outdoor Fitness" },
    { id: "personal_training", name: "Personal Training" },
    { id: "pilates", name: "Pilates" },
    { id: "rowing", name: "Rowing" },
    { id: "running", name: "Running" },
    { id: "small_group_training", name: "Small Group Training" },
    { id: "stairmaster", name: "Stairmaster" },
    { id: "stretching", name: "Stretching" },
    { id: "yoga", name: "Yoga" }
  ]
};

export const TABS = {
  General,
  Goals,
  Dashboard,
  Retention,
  Extra,
  Pages,
  ClubReady: Clubready
};
